<template>
  <v-layout>
    <div class="columns small-6 small-push-3">
      <h1>{{ $t('storeUserLogin.title') }}</h1>

      <form id="login" method="post">
        <fieldset class="warning">
          <div class="form-row inline-label">
            <div class="form-column">
              <label for="username" class="required">{{ $t('storeUserLogin.form.username.label') }}</label>
              <input id="username" v-model="username" type="text" name="username" autocomplete="off">
            </div>
          </div>
          <div class="form-row inline-label">
            <div class="form-column">
              <label for="password" class="required">{{ $t('storeUserLogin.form.password.label') }}</label>
              <input id="password" v-model="password" type="password" name="password" autocomplete="off">
            </div>
          </div>
        </fieldset>
        <fieldset class="submit">
          <div class="form-row">
            <div class="form-column">
              <input id="submit-login" :value="$t('storeUserLogin.form.submitButton')" type="submit" name="submit-login" @click.prevent="login">
            </div>
            <div class="form-column column-forgot-password">
              <a id="forgot-password-link" href="#" @click.prevent="openForgotPasswordModal()">{{ $t('storeUserLogin.form.forgotPasswordLink') }}</a>
            </div>
          </div>
        </fieldset>
      </form>
    </div>

    <v-modal v-if="errorCode !== null" @close="closeErrorModal()">
      <h2>&nbsp;</h2>
      <p>{{ $t(`storeUserLogin.errors.${errorCode}`) }}</p>
    </v-modal>

    <v-modal v-if="notification !== null" @close="closeNotificationModal()">
      <h2>&nbsp;</h2>
      <p>{{ $t(notification) }}</p>
    </v-modal>

    <v-store-user-forgot-password v-if="showForgotPasswordModal" @close="closeForgotPasswordModal()" @submit="submitForgotPasswordModal" />
  </v-layout>
</template>

<script>
import VLayout from '../layouts/Default'
import VModal from '../components/modals/Modal'
import VStoreUserForgotPassword from '../components/modals/StoreUserForgotPassword'
import authenticationMixin from '../mixins/authentication'
import bodyClassMixin from '../mixins/body-class'

export default {
  name: 'StoreUserLogin',
  components: {
    VLayout,
    VModal,
    VStoreUserForgotPassword
  },
  mixins: [
    authenticationMixin,
    bodyClassMixin
  ],
  data () {
    return {
      username: null,
      password: null,
      errorCode: null,
      notification: null,
      showForgotPasswordModal: false
    }
  },
  mounted () {
    this.redirectIfStoreUser()

    if (this.$route.params.error) {
      this.errorCode = this.$route.params.error
    }
    if (this.$route.params.flash) {
      this.notification = this.$route.params.flash
    }
  },
  methods: {
    redirectToCatalog () {
      this.$router.push({ name: 'ProductSelectionIndex' }).catch(() => {})
    },

    redirectIfStoreUser () {
      if (this.isStoreUser) {
        this.redirectToCatalog()
      }
    },

    async login () {
      if (this.username && this.password) {
        try {
          await this.$store.dispatch('user/storeUserLogin', {username: this.username, password: this.password})
          await this.$store.dispatch('user/fetchUser')
          this.errorCode = null
          this.redirectIfStoreUser()
        } catch (error) {
          if (error.code) {
            this.errorCode = error.code
          }
        }
      }
    },

    closeErrorModal () {
      this.errorCode = null
    },

    openForgotPasswordModal () {
      this.showForgotPasswordModal = true
    },

    closeForgotPasswordModal () {
      this.showForgotPasswordModal = false
    },

    async submitForgotPasswordModal (emailAddress) {
      this.showForgotPasswordModal = false
      try {
        await this.$container.userApiClient.requestPassword(emailAddress)
        this.notification = 'storeUserLogin.forgotPasswordModal.notification.forgotPasswordSentSuccess'
      } catch (error) {
        if (error.errors && error.errors.length > 0) {
          this.errorCode = error.errors[0].code
        }
      }
    },

    closeNotificationModal () {
      this.notification = null
    }
  }
}
</script>

<style scoped>
  form {
    width: 100%;
  }
  fieldset.submit {
    width: 100%;
  }
  fieldset.submit .form-column {
    width: 50%;
    float: left;
  }
  fieldset.submit .form-column.column-forgot-password {
    padding-top: 12px;
    text-align: right;
  }
</style>

<style>
  #forgot-password-dialog {
    max-width: 40rem;
  }
  #forgot-password-dialog form {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/StoreUserLogin.vue